<template>
    <div class="notifications-badge">
        <common-icon name="notifications" size="large"></common-icon>

        <common-badge :content="count"></common-badge>
    </div>
</template>

<script>
    export default {
        props: {
            count: { type: Number, required: true },
        },
    }
</script>
